import Vue from 'vue'
import Router from 'vue-router'




Vue.use(Router)

import AppMain from '@/components/AppMain'
import AppIntro from '@/components/AppIntro'
import AppArchive from '@/components/AppArchive'
import AppAbout from '@/components/AppAbout'
import WorksDetail from '@/components/WorksDetail'
import FormBook from '@/components/FormBook'
import BookResult from '@/components/BookResult'


export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'AppIntro',
      component: AppIntro
    },
    {
      path: '/main',
      name: 'AppMain',
      component: AppMain,
    },
    {
      path: '/about',
      name: 'AppAbout',
      component: AppAbout
    },
    {
      path: '/archive',
      name: 'AppArchive',
      component: AppArchive
    },
    {
      path: '/archive/:number',
      name: 'Works',
      component: WorksDetail
    },
    {
      path: '/formbook',
      name: 'FormBook',
      component: FormBook
    },
    {
      path: '/formbook/result',
      name: 'BookResult',
      component: BookResult
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js